export default __webpack_public_path__ + "static/media/4.7d1484fc.jpg";